import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type TrainingRemovedProps = BaseNotificationItemProps & {
  type: 'training_removed'
  program: {
    id: string
    displayName: string
    color: string
    iconType?: string
  }
}

export function TrainingRemoved({ program, ...props }: TrainingRemovedProps) {
  return (
    <NotificationItem
      {...props}
      title={`${program.displayName} Training Removed`}
      descriptionAddon={
        <p className='flex text-sm text-gray-500'>{`${program.displayName} training was removed from your profile.`}</p>
      }
    />
  )
}
